(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jhumka-box-page"]) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    /* Today's date in India, so the promised date does not shift with the visitor's device timezone */
    function deliveryDate(daysAhead) {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' })
        .format(new Date()).split('-');
      var d = new Date(Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10) + daysAhead));
      return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
    }

    /* Photo viewer */
    var viewer = null;
    function getViewer() {
      if (viewer) return viewer;
      var el = document.createElement('div');
      el.className = 'jb-lb';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Photo viewer');
      el.innerHTML =
        '<button type="button" class="jb-lb__close" aria-label="Close photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="jb-lb__nav jb-lb__nav--prev" aria-label="Previous photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<img class="jb-lb__img" alt="">' +
        '<button type="button" class="jb-lb__nav jb-lb__nav--next" aria-label="Next photo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '<p class="jb-lb__count"></p>';
      document.body.appendChild(el);
      var state = { items: [], i: 0, from: null };
      var img = el.querySelector('.jb-lb__img');
      var count = el.querySelector('.jb-lb__count');
      var prev = el.querySelector('.jb-lb__nav--prev');
      var next = el.querySelector('.jb-lb__nav--next');
      var closeBtn = el.querySelector('.jb-lb__close');
      var render = function () {
        var it = state.items[state.i];
        img.src = it.src;
        img.alt = it.alt || '';
        count.textContent = state.items.length > 1 ? (state.i + 1) + ' / ' + state.items.length : '';
        prev.hidden = next.hidden = state.items.length < 2;
      };
      var step = function (d) {
        var n = state.items.length;
        state.i = (state.i + d + n) % n;
        render();
      };
      var onKey = function (e) {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') step(1);
        else if (e.key === 'ArrowLeft') step(-1);
      };
      function close() {
        el.hidden = true;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        if (state.from && state.from.focus) state.from.focus();
      }
      closeBtn.addEventListener('click', close);
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      el.addEventListener('click', function (e) { if (e.target === el) close(); });
      var startX = null;
      el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 50 && state.items.length > 1) step(dx < 0 ? 1 : -1);
      });
      viewer = {
        open: function (items, index, from) {
          state.items = items;
          state.i = index;
          state.from = from;
          render();
          el.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', onKey);
          closeBtn.focus();
        }
      };
      return viewer;
    }
    function openPhotos(items, index, from) {
      if (items.length) getViewer().open(items, index, from);
    }

    function init(root) {
      if (!root || root.__jbReady) return;
      root.__jbReady = true;
      var qs = function (sel, ctx) { return (ctx || root).querySelector(sel); };
      var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

      /* Exact delivery date above the Buy button */
      var etaText = deliveryDate(parseInt(root.dataset.etaDays, 10) || 4);
      qsa('[data-eta-date]').forEach(function (el) { el.textContent = etaText; });
      qsa('[data-eta]').forEach(function (el) { el.hidden = false; });
      var stickyEta = qs('[data-sticky-eta]');
      if (stickyEta) stickyEta.textContent = 'Delivered by ' + etaText;

      /* Prepaid offer countdown (real end time) */
      var offer = qs('[data-offer]');
      if (offer) {
        var parsed = Date.parse(root.dataset.offerEnd || '');
        if (root.dataset.offerLive === 'true' && !isNaN(parsed) && parsed > Date.now()) {
          var pad = function (n) { return n < 10 ? '0' + n : String(n); };
          var timerEl = qs('[data-offer-timer]', offer);
          var iv;
          var tick = function () {
            var left = parsed - Date.now();
            if (left <= 0) {
              offer.hidden = true;
              clearInterval(iv);
              if (stickyEta) stickyEta.textContent = 'Delivered by ' + etaText;
              return;
            }
            var secs = Math.floor(left / 1000);
            var days = Math.floor(secs / 86400);
            var txt = (days ? days + 'd ' : '') + pad(Math.floor((secs % 86400) / 3600)) + ':' + pad(Math.floor((secs % 3600) / 60)) + ':' + pad(secs % 60);
            timerEl.textContent = txt;
            if (stickyEta) stickyEta.textContent = '₹' + (root.dataset.offerAmount || '400') + ' OFF ends in ' + txt;
          };
          tick();
          offer.hidden = false;
          iv = setInterval(tick, 1000);
        }
      }

      /* Gallery: swipe, mouse drag, arrows and endless looping */
      var stage = qs('[data-stage]');
      var slides = qsa('[data-slide]');
      var thumbs = qsa('[data-thumb]');
      var thumbWrap = qs('[data-thumbs]');
      var counter = qs('[data-gal-now]');
      var total = slides.length;
      function setThumb(i) {
        if (counter) counter.textContent = String(i + 1);
        thumbs.forEach(function (t, idx) {
          t.classList.toggle('is-on', idx === i);
          if (idx === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        var t = thumbs[i];
        if (t && thumbWrap) {
          thumbWrap.scrollTo({ left: t.offsetLeft - thumbWrap.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      var didDrag = false;
      if (stage && total > 1) {
        var width = function () { return stage.clientWidth || 1; };
        var smooth = reduce ? 'auto' : 'smooth';
        var lastClone = slides[total - 1].cloneNode(true);
        var firstClone = slides[0].cloneNode(true);
        [lastClone, firstClone].forEach(function (c) {
          c.removeAttribute('data-slide');
          c.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(c.querySelectorAll('img'), function (im) { im.loading = 'eager'; im.removeAttribute('fetchpriority'); });
        });
        stage.insertBefore(lastClone, slides[0]);
        stage.appendChild(firstClone);

        var place = function (index) { stage.scrollLeft = index * width(); };
        requestAnimationFrame(function () { place(1); });
        window.addEventListener('load', function () { if (Math.round(stage.scrollLeft / width()) === 0) place(1); });

        var settleTimer;
        var dragging = false;
        var settle = function () {
          if (dragging) return;
          var i = Math.round(stage.scrollLeft / width());
          if (i === 0) place(total);
          else if (i === total + 1) place(1);
        };
        var ticking = false;
        stage.addEventListener('scroll', function () {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 120);
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var i = Math.round(stage.scrollLeft / width());
            setThumb(((i - 1) % total + total) % total);
          });
        }, { passive: true });

        var goTo = function (index) { stage.scrollTo({ left: index * width(), behavior: smooth }); };
        var current = function () { return Math.round(stage.scrollLeft / width()); };
        thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i + 1); }); });
        var prev = qs('[data-prev]');
        var next = qs('[data-next]');
        if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
        if (next) next.addEventListener('click', function () { goTo(current() + 1); });
        stage.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') goTo(current() + 1);
          if (e.key === 'ArrowLeft') goTo(current() - 1);
        });
        window.addEventListener('resize', function () { place(((current() - 1) % total + total) % total + 1); });

        /* Mouse drag (touch screens already swipe natively) */
        var drag = null;
        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          didDrag = false;
          drag = { x: e.clientX, left: stage.scrollLeft, start: current() };
          dragging = true;
          stage.classList.add('is-drag');
          stage.setPointerCapture(e.pointerId);
        });
        stage.addEventListener('pointermove', function (e) {
          if (!drag) return;
          if (Math.abs(e.clientX - drag.x) > 5) didDrag = true;
          stage.scrollLeft = drag.left - (e.clientX - drag.x);
        });
        var endDrag = function (e) {
          if (!drag) return;
          var dx = e.clientX - drag.x;
          var target = drag.start + (dx < -40 ? 1 : dx > 40 ? -1 : 0);
          drag = null;
          dragging = false;
          stage.classList.remove('is-drag');
          goTo(target);
        };
        stage.addEventListener('pointerup', endDrag);
        stage.addEventListener('pointercancel', endDrag);
      }

      if (stage) {
        stage.addEventListener('click', function () {
          if (didDrag) { didDrag = false; return; }
          var items = slides.map(function (sl) { return { src: sl.dataset.zoom, alt: sl.dataset.zoomAlt || '' }; });
          var idx = 0;
          if (total > 1) {
            var i = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
            idx = ((i - 1) % total + total) % total;
          }
          openPhotos(items, idx, stage);
        });
      }

      /* Reviews: show a few, expand on request */
      var list = qs('[data-reviews]');
      var more = qs('[data-more]');
      if (list && more && qsa('.jb-rev', list).length > 4) {
        list.classList.add('is-collapsed');
        more.hidden = false;
        more.addEventListener('click', function () {
          var collapsed = list.classList.toggle('is-collapsed');
          more.textContent = collapsed ? 'Show more reviews' : 'Show fewer reviews';
        });
      }

      /* Review photos open in the viewer */
      var zoomBtns = qsa('[data-zoom-group="reviews"]');
      var zoomItems = zoomBtns.map(function (b) { return { src: b.dataset.zoom, alt: b.dataset.zoomAlt || '' }; });
      zoomBtns.forEach(function (b, i) {
        b.addEventListener('click', function () { openPhotos(zoomItems, i, b); });
      });

      /* Sticky bar: appears when the main Buy button is out of view */
      var mainCta = qs('[data-main-cta]');
      var sticky = qs('[data-sticky]');
      var endBand = qs('[data-end]');
      if (sticky && mainCta && 'IntersectionObserver' in window) {
        var mainVisible = true;
        var endVisible = false;
        var update = function () {
          var on = !mainVisible && !endVisible;
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        };
        new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; update(); }).observe(mainCta);
        if (endBand) new IntersectionObserver(function (e) { endVisible = e[0].isIntersecting; update(); }).observe(endBand);
      }
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-jb]')).forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector('[data-jb]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
